import React from 'react';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions/facilityActions';
import { TriangleAlert } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogBody,
} from '../ui/dialog';

const DeleteFacilityModal = ({
  facMetricsDeleteModal,
  showFacilityMetricDeleteModal,
  deleteFacilityData,
  facilitiesDeleteModal,
  showFacilitiesDeleteModal,
  deleteFacilities,
  showLoader,
}) => {
  const metricOpen = !!facMetricsDeleteModal?.status;
  const facilityOpen = !!facilitiesDeleteModal?.status;

  if (!metricOpen && !facilityOpen) return null;

  return (
    <>
      <Dialog
        open={metricOpen}
        onOpenChange={(open) => {
          if (!open) showFacilityMetricDeleteModal(false, null);
        }}>
        <DialogContent
          onClose={() => showFacilityMetricDeleteModal(false, null)}
          className='sm:max-w-md font-body'>
          <DialogHeader>
            <DialogTitle className='font-body'>Are you sure you wish to delete this facility metric?</DialogTitle>
            <DialogDescription>This action cannot be undone.</DialogDescription>
          </DialogHeader>
          <DialogFooter className='gap-2'>
            <Button
              onClick={() => deleteFacilityData(facMetricsDeleteModal.item.id)}
              variant='destructive'>
              Yes, please delete this data
            </Button>
            <Button
              id='cancel-facilityMetric-button'
              variant='outline'
              onClick={() => showFacilityMetricDeleteModal(false, null)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={facilityOpen}
        onOpenChange={(open) => {
          if (!open) showFacilitiesDeleteModal(false, null);
        }}>
        <DialogContent onClose={() => showFacilitiesDeleteModal(false, null)} className='sm:max-w-md font-body'>
          <DialogHeader>
            <DialogTitle className='font-body'>Are you sure you wish to delete this facility?</DialogTitle>
            <DialogDescription>This action cannot be undone.</DialogDescription>
          </DialogHeader>
          {facilitiesDeleteModal?.errorMsg ? (
            <DialogBody className='pt-0 pb-2'>
              <div
                role='alert'
                className='flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive'>
                <TriangleAlert size={16} strokeWidth={1.5} className='mt-0.5 shrink-0' aria-hidden />
                <span>{facilitiesDeleteModal.errorMsg}</span>
              </div>
            </DialogBody>
          ) : null}
          <DialogFooter className='gap-2'>
            <Button
              id='confirmDeleteFacilityBtn'
              onClick={() => deleteFacilities(facilitiesDeleteModal.item.id)}
              variant='destructive'
              disabled={!!facilitiesDeleteModal?.errorMsg}
              loading={showLoader}>
              Yes, please delete this data
            </Button>
            <Button
              id='cancel-facility-button'
              variant='outline'
              onClick={() => showFacilitiesDeleteModal(false, null)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    facMetricsDeleteModal: state.facility?.facilityDataDeleteModal,
    facilitiesDeleteModal: state.facility?.facilitiesDeleteModal,
    showLoader: state?.showLoader,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showFacilityMetricDeleteModal: (status, item) => dispatch(Actions.showFacilityMetricDeleteModal(status, item)),
  deleteFacilityData: (id) => dispatch(Actions.deleteFacilityData(id)),
  showFacilitiesDeleteModal: (status, item, errorMsg) => dispatch(Actions.showFacilitiesDeleteModal(status, item, errorMsg)),
  deleteFacilities: (id) => dispatch(Actions.deleteFacilities(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteFacilityModal);
